import React from 'react';
import './PastEvents.css';

import poonam from '../assets/posters/poonambadge.jpg';
import riya from '../assets/posters/riyabadge.jpg';
import divya from '../assets/posters/divyabadge.jpg';
import kunjal from '../assets/posters/kunjalbadge.jpg';
import yash from '../assets/posters/yashbadge.jpg';
import purva from '../assets/posters/purvabadge.jpg';

const pastPosters = [
    poonam,
    riya,
    divya,
    kunjal,
    yash,
    purva
];

const PastEvents = () => {
    return (
        <section className="past-events-section">
            <div className="posters-carousel-container">
                {/* This track will scroll in the reverse direction */}
                <div className="posters-carousel-track-reverse">
                    {/* Render posters twice for a seamless loop */}
                    {pastPosters.map((poster, index) => (
                        <div className="poster-card" key={`past1-${index}`}>
                            <img src={poster} alt={`Past Event Poster ${index + 1}`} />
                        </div>
                    ))}
                    {pastPosters.map((poster, index) => (
                        <div className="poster-card" key={`past2-${index}`}>
                            <img src={poster} alt={`Past Event Poster ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PastEvents;
